import { FETCH_USER_SUCCESS, FETCH_USER_TIMEOUT, SESSION_INVALID, FETCH_PLAIN_USER_SUCCESS } from "../actions/types";

export default (state = {
    error: null,
    users: [],
}, action) => {
  switch (action.type) {
      case FETCH_USER_SUCCESS:
          return {
            ...state,
              users: action.payload,
              key: action.key,
              test: action.test
        }
        break;
    case FETCH_USER_TIMEOUT:
          return {
            ...state,
            error: SESSION_INVALID
        }
          break;
      case FETCH_PLAIN_USER_SUCCESS:
          return {
              ...state,
              users: action.payload,
              key: action.key,
          }
          break;
    default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js